// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from '../page/login/Login';
import Dashboard from '../page/dashboard/Dashboard';
import Bill from '../components/bill/Bill';
import Home from '../components/home/Home';
import MenuItem from '../components/menuitem/MenuItem';
import ValueOfTime from '../components/price/Price';
import Profile from '../components/profile/Profile';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const setAuth = (auth) => {
        setIsAuthenticated(auth);
    };



    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login setAuth={setAuth} />} />
                <Route
                    path="/dashboard/*"
                    element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />}
                >
                    <Route index element={<Home />} />
                    <Route path="bills" element={<Bill />} />
                    <Route path="menuItems" element={<MenuItem />} />
                    <Route path="valueTimes" element={<ValueOfTime />} />
                    <Route path="profile" element={<Profile  />} />
                </Route>
            </Routes>
          
        </Router>
    );
}

export default App;
